import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  submitButton: {
    width: '100%',
    backgroundColor: '#635DFF',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',
    padding: '16px 20px',
    borderRadius: '12px',
    maxWidth: '600px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#5148E5'
    },
    '&:disabled': {
      backgroundColor: '#DEDEF1'
    }
  },
  anotherCardButton: {
    backgroundColor: '#000',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      color: '#000'
    }
  },
  errorMessage: {
    color: 'red',
    fontSize: '12px',
    margin: 0
  }
}))

export default useStyles
